import {SET_SPARES_BRAND_TYPE_LIST} from "../../Actions/ActionConstants";

const BrandTypeListReducer = (state = null, action) => {
    if (action.type === SET_SPARES_BRAND_TYPE_LIST) {
        return action.data;
    } else {
        return state;
    }
};
export default BrandTypeListReducer
